import React from 'react';

import { InfoBox } from '@infoods/lifebase-ui';
import classes from './CurrentPlanInfo.module.scss';
import { BillingPeriodType } from '../../../../../payment/constants/billingPeriodType';
import { BillingPeriodTypeChip } from '../../../../../payment';

type CurrentPlanInfoProps = {
  subscriptionName: string;
  billingPeriodType: BillingPeriodType;
};

const CurrentPlanInfo = ({
  subscriptionName,
  billingPeriodType,
}: CurrentPlanInfoProps) => (
  <InfoBox title="Current Plan" customMargin>
    <p className={classes.title}>{subscriptionName}</p>
    <BillingPeriodTypeChip billingPeriodType={billingPeriodType} />
  </InfoBox>
);

export { CurrentPlanInfo };
